import axios from '@axios'

const getDefaultState = () => ({
  items: [],
  item: null,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  },
})

export default {
  namespaced: true,
  state: getDefaultState,
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_ITEM(state, payload) {
      state.item = payload
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter(item => item.id !== id)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getItems({ commit }, params) {
      const { data } = await axios.get('/site-backups', { params })

      commit('SET_ITEMS', data.data)
      commit('SET_PAGINATION', data.meta.pagination)

      return data.data
    },
    async getItem({ commit }, id) {
      const { data } = await axios.get(`/site-backups/${id}`)

      commit('SET_ITEM', data.data)

      return data.data
    },
    async deleteItem({ commit }, id) {
      await axios.delete(`/site-backups/${id}`)

      commit('DELETE_ITEM', id)
    },
    async createItem(context, { siteId, source, title }) {
      await axios.post(`/site/${siteId}/backups/${source}`, { title })
    },
    async restoreItem(context, { id, sections }) {
      await axios.post(`/site-backups/${id}/restore`, { sections })
    },
    async getRestores(context, id) {
      const { data } = await axios.get(`/site-backups/${id}/restores`)

      return data.data
    },
  },
}
